module.exports = __webpack_public_path__ + "img/CCI.eb0b4f71.png";